/* src/app/components/review/processing/processing.component.scss */
.grey-header.heavy {
  background-color: rgba(202, 202, 202, 0.93);
}
:host-context(.dark-theme) .grey-header.heavy {
  background-color: #000000;
}
/*# sourceMappingURL=processing.component.css.map */
